// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"1a3bb237","230":"1c6e9082","257":"87721459","271":"6a0c4330","310":"ea3ea21d","402":"1bfdd506","408":"773bfb80","667":"20e81ce6","935":"f875b020","965":"22fe4a2b"}[chunkId] + ".chunk.js";
};